import React from 'react';
import { Tooltip } from 'reactstrap';

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneNumberPattern = /^(?:\+?1[—]?)?\(?([0-9]{3})\)?[—]?([0-9]{3})[—]?([0-9]{4})$/;
const phoneNumberPatternForSameDigits = /^(\d)(?!\1+$)\d{9}$/;
const phoneSeparator = /\(|\)|—/;

class EmailOrPhoneNumber extends React.Component {
    constructor(props) {
        super(props)
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.validateOnBlur = this.validateOnBlur.bind(this);
        this.validateOnMount = this.validateOnMount.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.state = {
            tooltipOpen: false,
            invalidInput: false
        };
    }

    componentDidMount() {
        const { validateOnMount } = this.props;

        if (validateOnMount) {
            this.validateOnMount();
        }
    }

    toggleTooltip() {
        this.setState(prevState => ({
            tooltipOpen: !prevState.tooltipOpen
        }));
    }

    onChange(event) {
        const { value } = event.target;
        const { isValid, isValidEmail, isValidPhone } = this.isValid(value);

        if (this.props.onChange) {
            this.props.onChange(value, { isValid, isValidEmail, isValidPhone });
        }

        if (this.state.invalidInput) {
            this.setState({invalidInput: !isValid});
        }
    }

    isPhoneNoNotSame(number) {
        let phoneNo = number.replace(/[^0-9]/g, '');
        if (!phoneNo) return false;
        let isPhoneNoNotSame = false;
        if (phoneNo.length < 11) {
            isPhoneNoNotSame = phoneNumberPatternForSameDigits.test(phoneNo);
        } else {
            isPhoneNoNotSame = phoneNumberPatternForSameDigits.test(phoneNo.substring(1));
        }
        return isPhoneNoNotSame;
    }


    isValid = (value) => {
        if (value && !this.props.inValidMsg) {
            const isValidEmail = (emailPattern.test(value) && (value.charAt(value.length - 1) !== '.'));
            const isValidPhone = phoneNumberPattern.test(value.replace(/\s/g, '')) && this.isPhoneNoNotSame(value);;
            return { isValid: value.trim() && (isValidEmail || isValidPhone), isValidEmail, isValidPhone }
        } else {
            return this.props.required && !this.props.inValidMsg ? { isValid: false } : { isValid: true };
        }
    }

    clearInput(event) {
        const e = { event, target: { value: "", name: this.props.name ? this.props.name : "" } };
        this.onChange(e);
    }

    validateOnBlur(event) {
        const value = event.target.value;
        const { isValid, isValidEmail, isValidPhone } = this.isValid(value);
        if (this.props.onChange) {
            this.props.onChange(value, { isValid, isValidEmail, isValidPhone });
        }
        event.persist();
        this.setState({ invalidInput: !isValid });
    }

    validateOnMount() {
        const value = this.props.value;
        const { isValid, isValidEmail, isValidPhone } = this.isValid(value);
        if (value && this.props.onChange) {
            this.props.onChange(value, { isValid, isValidEmail, isValidPhone });
        }
        if (this.state.invalidInput) {
            this.setState({ invalidInput: !isValid });
        }
    }

    isDuplicateAtTheRateInput = (e) => {
        const input = e.key;
        const inputText = e.target.value;
        return ((input === '@') && (inputText.indexOf('@') > -1)) ? true : false;
    };

    isConsecutivePointInput = (e) => {
        const input = e.key;
        const inputText = e.target.value;
        return ((inputText !== '') && (inputText.charAt(inputText.length - 1) === '.') && (input === '.')) ? true : false;
    };

    isInvalidInput = (e) => {
        const invalidCharacters = "!#$%^&*()+=[]\\\';,/{}|\":<>?";
        const input = e.key;
        return ((invalidCharacters.indexOf(input) > -1)) ? true : false;
    };

    isInvalidFirstCharacter = (e) => {
        const invalidCharacters = ".@";
        const inputChar = e.key;
        const inputText = e.target.value;
        return (inputText === '' && (invalidCharacters.indexOf(inputChar) > -1)) ? true : false;
    };

    onKeyPress = (e) => {
        if ((this.isDuplicateAtTheRateInput(e) || (this.isInvalidInput(e)) || (this.isInvalidFirstCharacter(e)) || (this.isConsecutivePointInput(e)))) {
            event.preventDefault();
        }
    }

    onKeyDown = (e) => {
        const target = e.target;
        if (target.selectionStart === target.selectionEnd) {
            if (e.keyCode === 46) { // delete key
                if (phoneSeparator.test(target.value[target.selectionStart])) {
                    target.selectionStart++;
                }
                this.deleted = true;
            }
            else if (e.keyCode === 8) {  // backspace key
                const char = target.value[target.selectionStart - 1];
                if (char === '(') {
                    this.prevented = true;
                    e.preventDefault();
                    return;
                }
                else if (char === ' ') {
                    target.selectionStart -= 3;
                }
                else if (phoneSeparator.test(char)) {
                    target.selectionStart -= 2;
                }
            }
        }
    }

    onKeyUp = (e) => {
        if (this.prevented || e.ctrlKey || e.altKey || e.shiftKey) {
            this.prevented = false;
            return;
        }
        const target = e.target;
        const value = target.value;
        const selectionStart = target.selectionStart;
        const mDash = '—';
        const currentInput = value.replace('(', '').replace(')', '').replace(mDash, '').replace(/ /g, '');
        const isNumber = currentInput.indexOf('.') === -1 && currentInput && !isNaN(currentInput) ? true : false;
        if (isNumber) {
            this.formatPhoneNumber(e, currentInput, mDash);
        }
        else {
            target.value = value.replace('(', '').replace(')', '').replace(mDash, '').replace(/ /g, '');
        }
        const diff = target.value.length - value.length;
        target.selectionStart = selectionStart + (!this.deleted && diff > 0 ? (selectionStart === 5 || selectionStart === 6 ? diff - 1 : diff) : 0);
        if (phoneSeparator.test(value[selectionStart]) && (value.indexOf('(') > -1 || target.value.indexOf('(') === -1)) {
            target.selectionStart++;
        }
        target.selectionEnd = target.selectionStart;
        this.deleted = false;
        this.onChange(e);
    };

    formatPhoneNumber(e, currentInput, mDash) {
        let formatTarget = e.target;
        const lenOfInput = currentInput.length;
        const isCountryCode = currentInput.charAt(0) === '1' ? true : false;
        if (isCountryCode) {
            switch (lenOfInput) {
                case 1:
                    formatTarget.value = currentInput;
                    break;
                case 2: case 3: case 4:
                    formatTarget.value = currentInput.slice(0, 1) + " (" + currentInput.slice(1) + ") ";
                    break;
                case 5: case 6: case 7:
                    formatTarget.value = currentInput.slice(0, 1) + " (" + currentInput.slice(1, 4) + ") " + currentInput.slice(4);
                    break;
                case 8: case 9: case 10: case 11:
                    formatTarget.value = currentInput.slice(0, 1) + " (" + currentInput.slice(1, 4) + ") " + currentInput.slice(4, 7) + mDash + currentInput.slice(7);
                    break;
                default:
                    formatTarget.value = currentInput.slice(0, 1) + " (" + currentInput.slice(1, 4) + ") " + currentInput.slice(4, 7) + mDash + currentInput.slice(7, 11);
            }
        }
        else {
            switch (lenOfInput) {
                case 1: case 2: case 3:
                    formatTarget.value = currentInput;
                    break;
                case 4: case 5: case 6: case 7:
                    formatTarget.value = currentInput.slice(0, 3) + mDash + currentInput.slice(3);
                    break;
                case 8: case 9: case 10:
                    formatTarget.value = "(" + currentInput.slice(0, 3) + ") " + currentInput.slice(3, 6) + mDash + currentInput.slice(6);
                    break;
                default:
                    formatTarget.value = "(" + currentInput.slice(0, 3) + ") " + currentInput.slice(3, 6) + mDash + currentInput.slice(6, 10);
            }
        }
    };

    render() {
        const {
            placeholder,
            value,
            required,
            name,
            id,
            autoFocus,
            disabled,
            inputErrorMsg,
            tooltipID,
            tooltipMsg,
            inValidMsg,
            showAsInvalid,
            showClearBtn
        } = this.props;

        const isValid = this.isValid(value);
        const containerClassName = (value ? ' input-not-empty' : '') + (this.state.invalidInput || showAsInvalid ? ' input-invalid' : '') + ((tooltipID && tooltipMsg) ? ' input-append' : '') + (showClearBtn ? ' input-clear-btn' : '');

        return (
            <div className={'il-group' + containerClassName}>
                <input
                    type="text"
                    className="form-control"
                    value={value}
                    required={required}
                    name={name}
                    id={id}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    placeholder={placeholder ? placeholder : 'Mobile Number or Email'}
                    onChange={e => this.onChange(e)}
                    onBlur={this.validateOnBlur}
                    title={placeholder ? "Please fill out a " + placeholder : "Please fill out a Mobile Number or Email."}
                    aria-label={placeholder ? placeholder : 'Mobile Number or Email'}
                    onKeyPress={e => this.onKeyPress(e)}
                    onKeyDown={e => this.onKeyDown(e)}
                    onKeyUp={e => this.onKeyUp(e)}
                />
                {tooltipID && tooltipMsg && (
                    <div className="input-icon-append ">
                        <span className="icon-info" id={tooltipID} />
                        <Tooltip
                            placement="top"
                            isOpen={this.state.tooltipOpen}
                            autohide={false}
                            target={tooltipID}
                            toggle={this.toggleTooltip}
                        >
                            {tooltipMsg}
                        </Tooltip>
                    </div>
                )}
                {showClearBtn && value &&
                    <div className="clear-btn-container">
                        <button className="clear-btn" type="button" aria-label="clear button" onClick={this.clearInput}><span className="icon-input-clear" /></button>
                    </div>
                }
                <div className="il-label" aria-hidden="true">{placeholder}</div>
                {inValidMsg ? <div className="input-error-msg">{inValidMsg}</div> : !isValid.isValid &&
                    <div className="input-error-msg">{inputErrorMsg
                        ? inputErrorMsg
                        : typeof value !== "undefined" && value ? `Please enter a valid ${placeholder ? placeholder : 'mobile number or email'}.` : ""
                    }</div>
                }
            </div>
        )
    }
}
export default EmailOrPhoneNumber;